var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("EditarRegistro"),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            { staticClass: "grey lighten-2 text--info" },
            [
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { staticClass: "px-3" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            color: "primary",
                            to:
                              "/registro-manual-asistencia/listado/" +
                              _vm.esUsuario +
                              "/"
                          }
                        },
                        [_c("v-icon", [_vm._v("arrow_back")])],
                        1
                      ),
                      _vm._v(" "),
                      _c("strong", [
                        _vm._v(
                          " \n              Crear solicitud de nuevo registro de asistencia manual\n            "
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { "lazy-validation": "" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.save()
                    }
                  },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "date",
                                  label: "Fecha inicio",
                                  rules: _vm.$validate(["required"]),
                                  required: ""
                                },
                                model: {
                                  value: _vm.form.fecha_desde,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_desde", $$v)
                                  },
                                  expression: "form.fecha_desde"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "date",
                                  label: "Fecha fin",
                                  rules: _vm.$validate(["required"]),
                                  required: ""
                                },
                                model: {
                                  value: _vm.form.fecha_hasta,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_hasta", $$v)
                                  },
                                  expression: "form.fecha_hasta"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "time",
                                  label: "Hora ingreso mañana :"
                                },
                                model: {
                                  value: _vm.form.hora_ingreso_mañana,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "hora_ingreso_mañana",
                                      $$v
                                    )
                                  },
                                  expression: "form.hora_ingreso_mañana"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "time",
                                  label: "Hora salida mañana"
                                },
                                model: {
                                  value: _vm.form.hora_salida_mañana,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "hora_salida_mañana",
                                      $$v
                                    )
                                  },
                                  expression: "form.hora_salida_mañana"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "time",
                                  label: "Hora ingreso tarde :"
                                },
                                model: {
                                  value: _vm.form.hora_ingreso_tarde,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "hora_ingreso_tarde",
                                      $$v
                                    )
                                  },
                                  expression: "form.hora_ingreso_tarde"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "time",
                                  label: "Hora salida tarde"
                                },
                                model: {
                                  value: _vm.form.hora_salida_tarde,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "hora_salida_tarde", $$v)
                                  },
                                  expression: "form.hora_salida_tarde"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("\n              Respaldo\n            ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c("v-flex", { attrs: { md12: "" } }, [
                            _c("input", {
                              ref: "file",
                              attrs: {
                                type: "file",
                                accept: "application/pdf",
                                rules: _vm.$validate(["required"]),
                                required: ""
                              },
                              on: {
                                change: function($event) {
                                  return _vm.handleFileUpload2()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.errors2.file
                              ? _c("p", { staticClass: "red--text body-1" }, [
                                  _vm._v(
                                    "\n                  *Debe seleccionar un archivo\n                "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.errors2.denied
                              ? _c("p", { staticClass: "red--text body-1" }, [
                                  _vm._v(
                                    "\n                  *Formato no admitido por el sistema\n                "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _c("v-spacer"),
                              _vm._v(" "),
                              _vm.habilitar_btn == false
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "success",
                                        block: "",
                                        type: "submit",
                                        disabled: !_vm.valid
                                      }
                                    },
                                    [
                                      _c("v-icon", [_vm._v("arrow_downward")]),
                                      _vm._v(
                                        "\n                  Registrar\n                "
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-form",
                {
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        [
                          _vm.permiso_detalles != null &&
                          _vm.habilitar_btn == true
                            ? _c("h3", [
                                _c("strong", [_vm._v("Detalles de papeleta")])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("v-data-table", {
                            staticClass: "elevation-1",
                            attrs: {
                              items: _vm.permiso_detalles,
                              "hide-actions": "",
                              headers: _vm.headers
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "items",
                                fn: function(props) {
                                  return [
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(props.item.fecha) +
                                            "\n\t\t\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(props.item.ingreso_am) +
                                            "\n\t\t\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [_vm._v(_vm._s(props.item.salida_am))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [_vm._v(_vm._s(props.item.ingreso_pm))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [_vm._v(_vm._s(props.item.salida_pm))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          _vm._s(props.item.estado_detalle)
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "primary",
                                              icon: "",
                                              title: "Modificar registro"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.editarRegistro(
                                                  props.item
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("edit")])],
                                          1
                                        ),
                                        _vm._v(" "),
                                        props.item.id_estado_detalle == 22 ||
                                        props.item.id_estado_detalle == 7 ||
                                        props.item.id_estado_detalle == 16
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  color: "error",
                                                  icon: "",
                                                  title: "Eliminar registro"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.eliminarRegistro(
                                                      props.item,
                                                      9
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-icon", [_vm._v("delete")])
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        props.item.id_estado_detalle == 9
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  color: "warning",
                                                  icon: "",
                                                  title: "Habilitar registro"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.eliminarRegistro(
                                                      props.item,
                                                      22
                                                    )
                                                  }
                                                }
                                              },
                                              [_c("v-icon", [_vm._v("done")])],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "small",
                        { staticClass: "error--text text-required" },
                        [_vm._v("* Los campos son obligatorios")]
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            to:
                              "/registro-manual-asistencia/listado/" +
                              _vm.esUsuario +
                              "/"
                          }
                        },
                        [
                          _c("v-icon", [_vm._v("cancel")]),
                          _vm._v("CERRAR\n\t\t\t\t\t")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3bda31c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bda31c2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/registro_manual_asistencia/CrearRegistroAsistenciaManual.vue
// module id = null
// module chunks = 